import { cn } from "../../lib/utils";

const Card = ({ title, children, className }) => {
  return (
    <div
      className={cn(
        "bg-white rounded-2xl shadow-sm border border-slate-200 p-6",
        className
      )}
    >
      {title && (
        <div className="border-b border-slate-200 pb-4 mb-4">
          <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
        </div>
      )}
      {children}
    </div>
  );
};

export default Card;
